import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardHomeComponent } from './dashboard-home/dashboard-home.component';
// import { userDataResolver } from './resolver/user-data.resolver';

const routes: Routes = [
  {
    path: '',
    component: DashboardHomeComponent,
    // resolve: { user: userDataResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
